import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { CampaignCouponsComponent } from '../campaign-coupons.component';
import { CouponService } from '../../../../../../services/campaign/coupon.service';

@Component({
  selector: 'app-category-coupons-slider',
  templateUrl: './category-coupons-slider.component.html',
  styleUrls: ['./category-coupons-slider.component.css']
})

export class CategoryCouponsSliderComponent implements OnInit, OnChanges {
  @Input() coupon: any;
  @Input() selectedCategories: any[];
  @Input() category: any;
  @Input() typeCode: number;
  @Input() returnedSavedCategories: any[];
  @Input() suggestedCategoriesData: any[];

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCouponSettings() {
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor(private campaignCouponsComponent: CampaignCouponsComponent, private couponService: CouponService) { }

  showCategorySliders() {
    let categoryToFind = this.category.codice_categoria;
    categoryToFind = categoryToFind.toString();
    this.selectedCategories.indexOf(categoryToFind) > -1 ? this.category.visible = true : this.category.visible = false;
  }

  ngOnInit() {
    let couponData: any;
    if (this.returnedSavedCategories[0] && this.returnedSavedCategories[0].length > 0) {
      this.returnedSavedCategories[0].map(val => {
        if (val.codice_categoria === this.category.codice_categoria) {
          Object.assign(this.category, val);
        }
      });
    } else if (this.suggestedCategoriesData && this.suggestedCategoriesData.length > 0) {
      this.suggestedCategoriesData.forEach(suggestedCat => {
        if (this.category.codice_categoria === suggestedCat.codice_categoria) {
          couponData = {
            offerta: suggestedCat.offerta_utente,
            stretch: suggestedCat.stretch_utente,
            soglia: [suggestedCat.soglia_min_utente, suggestedCat.soglia_max_utente],
            visible: false,
            soglia_min: this.coupon.soglia_min,
            soglia_max: this.coupon.soglia_max,
            step: suggestedCat.ampiezza_step_utente
          }
        }
      })
    } else {
      couponData = {
        offerta: this.coupon.offerta,
        stretch: this.coupon.stretch,
        soglia: this.coupon.soglia,
        visible: false,
        soglia_min: this.coupon.soglia_min,
        soglia_max: this.coupon.soglia_max,
        step: this.coupon.ampiezza_step
      }
    }

    if (!this.category.offerta) {
      Object.assign(this.category, couponData); // category estesa per distinzione dati in ciascuna categoria
    }

    let sogliaSlider = this.couponService.sliderSteps(this.category.soglia_min, this.category.soglia_max, 5);
    Object.assign(this.category, {soglia_slider: sogliaSlider});

    if (this.category.codice_categoria) {
      if (this.coupon.categories && this.coupon.categories.length > 0) {
        this.coupon.categories.map(cat => {
          if (cat === this.category.codice_categoria.toString()) {
            this.category.visible = true
          }
        })
      } else {
        this.showCategorySliders();
      }
    }

  }


  ngOnChanges(changes) {
    if (changes.hasOwnProperty('selectedCategories')) {
      this.selectedCategories = changes.selectedCategories.currentValue;
    }
    this.showCategorySliders();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupons-slider.component.ts